var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_593_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35512 8.23666C7.12129 8.23666 6.89703 8.32956 6.73169 8.4949C6.56634 8.66024 6.47345 8.8845 6.47345 9.11833V12.645H8.23679V10H10.8818V12.2042L13.9676 9.11833L10.8818 6.0325V8.23666H7.35512ZM10.6235 0.648155L19.352 9.37666C19.5173 9.542 19.6101 9.76621 19.6101 10C19.6101 10.2338 19.5173 10.458 19.352 10.6233L10.6235 19.3518C10.4581 19.5171 10.2339 19.61 10.0001 19.61C9.76633 19.61 9.54212 19.5171 9.37678 19.3518L0.648277 10.6233C0.48299 10.458 0.390137 10.2338 0.390137 10C0.390137 9.76621 0.48299 9.542 0.648277 9.37666L9.37678 0.648155C9.54212 0.482868 9.76633 0.390015 10.0001 0.390015C10.2339 0.390015 10.4581 0.482868 10.6235 0.648155Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_593_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.22,
    height: 19.22,
    fill: "white",
    transform: "translate(0.390137 0.390015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMap);
export default __webpack_public_path__ + "static/media/googleMap.1025816e26cdb96e9de1d0278547824e.svg";
export { ForwardRef as ReactComponent };